import PageHero from "@/components/PageHero";
import { LegalSection, LegalNote } from "@/components/Legal";
import useSEO from "@/hooks/useSEO";
import { COMPANY } from "@/data/content";

const Privacy = () => {
  useSEO(
    "Privacy Policy — SSDE LTD",
    "How SSDE LTD collects, uses and protects personal information submitted through this website."
  );
  return (
    <>
      <PageHero
        testId="privacy-hero"
        eyebrow="Legal"
        titleLines={["Privacy Policy."]}
        lede={`How ${COMPANY.name} handles personal information provided through this website.`}
      />
      <section className="bg-offwhite py-16 sm:py-24" data-testid="privacy-content">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 space-y-8">
          <LegalNote />
          <LegalSection title="1. Who We Are" testId="privacy-who">
            <p>
              SSDE LTD ("we", "us", "our") is a UK-based creative design company
              registered at {COMPANY.address}. You can contact us at{" "}
              <a href={`mailto:${COMPANY.email}`} className="text-gold-deep underline underline-offset-2">{COMPANY.email}</a>{" "}
              or by telephone on {COMPANY.phone}.
            </p>
          </LegalSection>
          <LegalSection title="2. Information We Collect" testId="privacy-collect">
            <p>
              When you submit our contact form, we collect the details you provide:
              your name, email address, telephone number (optional), the service you
              are interested in, your indicative budget (optional) and your project
              details.
            </p>
            <p>
              We do not use advertising trackers on this website, and we do not
              collect special-category personal data.
            </p>
          </LegalSection>
          <LegalSection title="3. How We Use Your Information" testId="privacy-use">
            <p>
              We use the information you provide solely to respond to your enquiry,
              discuss your project requirements and, where agreed, provide our design
              services. We do not sell, rent or share your personal information with
              third parties for marketing purposes.
            </p>
          </LegalSection>
          <LegalSection title="4. How Long We Keep It" testId="privacy-retention">
            <p>
              Enquiry details are retained only for as long as necessary to handle
              your enquiry and any resulting project, after which they are securely
              deleted.
            </p>
          </LegalSection>
          <LegalSection title="5. Your Rights" testId="privacy-rights">
            <p>
              Under UK data protection law, you have the right to request access to,
              correction of, or deletion of your personal data. To exercise any of
              these rights, contact us at{" "}
              <a href={`mailto:${COMPANY.email}`} className="text-gold-deep underline underline-offset-2">{COMPANY.email}</a>.
              You also have the right to raise a concern with the Information
              Commissioner's Office (ICO).
            </p>
          </LegalSection>
          <LegalSection title="6. Changes to This Policy" testId="privacy-changes">
            <p>
              We may update this policy from time to time. The current version will
              always be published on this page.
            </p>
            <p className="text-xs text-charcoal/50">Last updated: July 2026</p>
          </LegalSection>
        </div>
      </section>
    </>
  );
};

export default Privacy;
